<template>
  <div class="dashboard-welcome mt-24">
    <a-card :bordered="false" class="header-solid dashboard-welcome-card mb-15">
      <a-row type="flex" align="middle" :gutter="[24, 24]">
        <a-col :span="24" :lg="16">
          <div class="welcome-profile">
            <a-avatar :size="64" class="welcome-avatar">
              {{ avatarText }}
            </a-avatar>
            <div>
              <p class="welcome-subtitle">{{ greeting }}</p>
              <h2 class="welcome-title">欢迎进入系统，{{ displayName }}</h2>
              <p class="welcome-desc">
                当前账号已登录，可以从左侧菜单开始处理业务。
              </p>
            </div>
          </div>
        </a-col>
        <a-col :span="24" :lg="8" class="welcome-tags">
          <!-- <a-tag color="blue">{{ roleName }}</a-tag>
          <a-tag color="green">{{ departmentName }}</a-tag> -->
        </a-col>
      </a-row>
    </a-card>

    <a-card :bordered="false" class="header-solid mt-24">
      <template #title>
        <h5 class="font-semibold m-0">账户信息</h5>
      </template>

      <a-descriptions bordered :column="descriptionColumn">
        <a-descriptions-item
          v-for="item in accountItems"
          :key="item.label"
          :label="item.label"
        >
          {{ item.value }}
        </a-descriptions-item>
      </a-descriptions>
    </a-card>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["userinfo"]),
    user() {
      return this.userinfo || {};
    },
    displayName() {
      return this.user.real_name || this.user.username || "用户";
    },
    avatarText() {
      return this.displayName.slice(0, 1).toUpperCase();
    },
    greeting() {
      const hour = new Date().getHours();

      if (hour < 6) return "夜深了，注意休息";
      if (hour < 12) return "早上好";
      if (hour < 18) return "下午好";
      return "晚上好";
    },
    roleName() {
      const role = this.user.sys_role || this.user.role || {};
      return role.role_name || "暂无角色";
    },
    departmentName() {
      const department = this.user.department || {};
      return department.department_name || "暂无部门";
    },
    genderText() {
      if (this.user.user_gender === "1") return "男";
      if (this.user.user_gender === "2") return "女";
      return "未设置";
    },
    createTimeText() {
      return this.formatDate(this.user.create_time);
    },
    descriptionColumn() {
      return {
        xxl: 2,
        xl: 2,
        lg: 2,
        md: 2,
        sm: 1,
        xs: 1,
      };
    },
    accountItems() {
      return [
        { label: "真实姓名", value: this.valueOrEmpty(this.user.real_name) },
        { label: "登录账号", value: this.valueOrEmpty(this.user.username) },
        { label: "所属部门", value: this.departmentName },
        { label: "用户角色", value: this.roleName },
        { label: "员工手机号", value: this.valueOrEmpty(this.user.user_phone) },
        { label: "联系邮箱", value: this.valueOrEmpty(this.user.user_email) },
        { label: "性别", value: this.genderText },
        { label: "创建时间", value: this.createTimeText },
        { label: "用户备注", value: this.valueOrEmpty(this.user.user_remark) },
      ];
    },
  },
  methods: {
    valueOrEmpty(value) {
      return value || "暂无";
    },
    formatDate(value) {
      if (!value) {
        return "暂无";
      }

      const date = new Date(value);
      if (Number.isNaN(date.getTime())) {
        return value;
      }

      const pad = (num) => String(num).padStart(2, "0");
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
        date.getDate()
      )} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.dashboard-welcome {
  .dashboard-welcome-card {
    background: #ffffff;
  }

  .welcome-profile {
    display: flex;
    align-items: center;
    gap: 18px;
  }

  .welcome-avatar {
    flex: 0 0 auto;
    color: #ffffff;
    font-size: 26px;
    font-weight: 600;
    background: #1677ff;
  }

  .welcome-subtitle {
    margin: 0 0 6px;
    color: #8c8c8c;
    font-size: 14px;
  }

  .welcome-title {
    margin: 0;
    color: #141414;
    font-size: 24px;
    font-weight: 700;
    line-height: 1.35;
  }

  .welcome-desc {
    margin: 8px 0 0;
    color: #595959;
    font-size: 14px;
  }

  .welcome-tags {
    text-align: right;
  }

  @media (max-width: 991px) {
    .welcome-tags {
      text-align: left;
    }
  }

  @media (max-width: 575px) {
    .welcome-profile {
      align-items: flex-start;
    }

    .welcome-title {
      font-size: 20px;
    }
  }
}
</style>
